/**
 * Centrální místo pro identifikační a kontaktní údaje firmy používané napříč
 * legislativními stránkami (Obchodní podmínky, GDPR, Cookies, Reklamační řád
 * apod.). Stačí doplnit prázdná pole označená "" — nikde jinde už nic měnit
 * nemusíš, všechny stránky se automaticky aktualizují.
 *
 * Pole, která jsou prázdná, se na webu zobrazí jako "—" nebo s elegantní
 * "doplníme" placeholder hláškou. Nic se nerozbije.
 */
export const COMPANY = {
  // Obchodní jméno (jak je to v živnostenském/obchodním rejstříku)
  legalName: "Jarmila Červená", // OSVČ — fyzická osoba podnikající
  tradeName: "Apex Detailing",

  // Identifikace
  ico: "29925584",
  dic: "",
  isVatPayer: false,

  // Forma podnikání – výchozí je OSVČ. Pokud máte s.r.o., přepište na "sro" a
  // doplňte registerEntry níže.
  legalForm: "osvc", // "osvc" | "sro"

  // Pro OSVČ: živnostenský rejstřík
  tradeRegister: {
    office: "Úřad městské části Praha 20",
    fileNumber: "",
  },

  // Pro s.r.o.: obchodní rejstřík (vyplň jen pokud legalForm = "sro")
  commercialRegister: {
    court: "", // ← např. "Krajský soud v Praze"
    fileNumber: "", // ← Spisová značka, např. "C 12345"
  },

  // Sídlo / místo podnikání
  address: {
    street: "Ježkova 627",
    city: "Zeleneč",
    zip: "250 91",
    country: "Česká republika",
    full: "Ježkova 627, 250 91 Zeleneč",
  },

  // Kontakt
  contact: {
    email: "apexdetailingprague@gmail.com",
    phone: "+420 604 447 377",
    phoneRaw: "+420604447377",
  },

  // Provozovatel (statutární / odpovědná osoba)
  owner: {
    name: "Jarmila Červená",
    role: "Majitelka · Apex Detailing",
  },

  // Datum účinnosti aktuálního znění legislativních dokumentů
  // (změňte při každé aktualizaci)
  effectiveDate: "14. 9. 2026",

  // Odkazy pro řešení sporů
  links: {
    coi: "https://adr.coi.cz/cs",
    eccNet: "https://www.eccnet.eu",
    uoouCz: "https://www.uoou.cz",
  },

  // Subprocesory (zpracovatelé osobních údajů, které reálně využíváme)
  subprocessors: [
    { name: "Brevo (Sendinblue SAS)", purpose: "Rozesílání transakčních e-mailů (potvrzení rezervace, platba, připomínky)", country: "Francie / EU" },
    { name: "Stripe Payments Europe Ltd.", purpose: "Zpracování online plateb kartou", country: "Irsko / EU" },
    { name: "[DOPLNIT poskytovatele hostingu]", purpose: "Provoz serveru a databáze s rezervacemi", country: "[DOPLNIT, EU]" },
    { name: "Google LLC (Google Maps, Google Calendar)", purpose: "Mapové podklady a generování odkazů do kalendáře", country: "USA (Standardní smluvní doložky)" },
    { name: "Google Ireland Ltd. (Google Ads)", purpose: "Měření konverzí a vyhodnocení reklamních kampaní (pouze se souhlasem)", country: "Irsko / EU, přenos do USA na základě Standardních smluvních doložek" },
  ],
};
